import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, Grid, Box } from '@mui/material';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';
import { useFetchOrganizationsQuery } from '../features/api/rest/apiOrganizationsSlice';
import OrganizationCard from './OrganizationCard';
import OrganizationDialog from './OrganizationDialog';
import Spinner from './Spinner';
import Error from './Error';

function Organizations() {
  const { t } = useTranslation();
  const [isAdding, setIsAdding] = useState(false);
  const { data: organizations = [], isFetching: isOrgFetching, isLoading: isOrgLoading, isError: isOrgError } = useFetchOrganizationsQuery({ refetchOnMountOrArgChange: true });
  const { data: profile, isFetching: isProfileFetching, isLoading: isProfileLoading, isError: isProfileError } = useGetProfileQuery();

  if (isOrgFetching || isProfileFetching || isOrgLoading || isProfileLoading) return <Spinner />;

  if (isOrgError || isProfileError) return <Error />;

  return (
    <Box>
      <Typography variant="h4">{t('organizations.organizations')}</Typography>
      <Button variant="contained" onClick={() => setIsAdding(true)} sx={{ my: 1 }}>
        {t('organizations.newOrganization')}
      </Button>
      {organizations.length === 0 ? (
        <Typography variant="h5" sx={{ mt: 3 }}>
          {t('organizations.noOrganizations')}
        </Typography>
      ) : (
        <Grid id="Organization_Grid">
          {organizations.map((organization) => (
            <OrganizationCard
              key={organization.id}
              id={organization.id}
              name={organization.name}
              slug={organization.slug}
              isAdmin={profile.is_staff || (!!organization.users && organization.users.some((user) => user.is_admin && profile.id === user.user))}
              isActive={organization.is_active}
            />
          ))}
        </Grid>
      )}
      <OrganizationDialog actionType="add" isOpen={isAdding} setIsOpen={setIsAdding} />
    </Box>
  );
}

export default Organizations;
